import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { medfordConfig } from "./data";

export default function MedfordPage() {
  return <OregonCityPageTemplate config={medfordConfig} />;
}